import { jwtDecode } from "jwt-decode";
export var getUserRole = function () {
    var token = sessionStorage.getItem('token');
    if (!token)
        return null;
    try {
        var decoded = jwtDecode(token);
        var role = decoded.role.slice(5);
        console.log("getUserRole()", role);
        return role;
    }
    catch (_a) {
        return null;
    }
};
export var getUserName = function () {
    var token = sessionStorage.getItem('token');
    if (!token)
        return null;
    try {
        var decoded = jwtDecode(token);
        var username = decoded.sub;
        console.log("getUserName()", username);
        return username;
    }
    catch (_a) {
        return null;
    }
};
